import React from "react"
import AuthImage from "../../../images/svg/login-illustration.svg"
import styles from './rightsidecomponent.module.scss'

export default _ => {
  return (
    <div className={styles.container}>
        <AuthImage />
    </div>
  )
}

